
//account
export const SET_CURRENT_USER = "setCurrentUser";
export const VALIDATE_USER = "validateUser";
export const VERIFY_2FA = "verifyTwoFactorAuthentication";
export const SET_CURRENT_USER_EMAIL = "setCurrentUserEmail";
export const LOGIN = "logIn";
export const LOGOUT = "logOut";
export const SET_PRODUCT = "setProduct"; 
export const SET_PRODUCT_FIELD = "setProductField"; 


export const SET_PRODUCT_REGISTRATION = "setProductRegistration"; 
export const SET_PRODUCT_REGISTRATION_FIELD = "setProductRegistrationField";

//loader
export const UPDATE_LOADING_STATUS = "updateLoadingStatus";
export const SET_LOADING_STATUS = "setLoadingStatus";

//loader
export const UPDATE_TOAST_NOTIFICATION = "updateToastNotification";
export const SET_TOAST_NOTIFICATION = "setToastNotification";
export const SET_TOAST_NOTIFICATION_FIELD = "setToastNotificationField";
export const SHOW_TOAST_NOTIFICATION = "showToastNotification";



//cookies
export const GET_PRIVACY_CONSENT = "getPrivacyConsent";
export const UPDATE_PRIVACY_CONSENT = "updatePrivacyConsent";
export const SET_PRIVACY_CONSENT = "setPrivacyConsent";
export const SET_PRIVACY_CONSENT_FIELD = "setPrivacyConsentField";